import React from 'react';
import { render } from 'react-dom';
import App from './components/App';

import './css/style.css';

const Root = () => { 
  return <App /> 
};

render(<Root/>, document.querySelector('#main'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/